import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/recommendation-modal.css";
import {
  fetchLeakedSession,
  fetchLeakedSessionGraph,
  addLeakedSession,
  fetchLeakedSessionAction,
} from "../../actions/leakedCredentials";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import NoData from "../common/noDataComponetnt";
import AccessPage from "../Shared/accessPage";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import $, { data } from "jquery";
import { rescanSingle } from "../../actions/users";
import { toastr } from "react-redux-toastr";

const LeakedSession = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const auth = useSelector((state) => state?.auth?.user);

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState("");
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [domainvalue, setDomains] = useState("");
  const [domainSelected, setDomainSelected] = useState("all");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [limit, setLimit] = useState(10);
  const state = useSelector(
    (state) => state?.leakedCredential?.sessions?.data?.data
  );

  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });

  const domainValue = useSelector(
    (state) => state?.leakedCredential?.sessions?.data?.domains
  );

  const totalCount = useSelector(
    (state) => state?.leakedCredential?.sessions?.data?.totalLeakedSessions
  );


  let oldDnsDetails = useSelector(
    (state) => state?.leakedCredential?.leakedGraph?.data
  );

  const [showAddSessionModal, setShowAddSessionModal] = useState(false);
  const [inputMethod, setInputMethod] = useState("single");
  const [jsonData, setJsonData] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  
  // Single session fields
  const [sessionName, setSessionName] = useState("");
  const [sessionValue, setSessionValue] = useState("");
  const [sessionDomain, setSessionDomain] = useState("");
  const [sessionPath, setSessionPath] = useState("/");
  const [foundLocation, setFoundLocation] = useState("");
  const [sessionExpires, setSessionExpires] = useState("");

  // Add session modal
  const [isAddSessionModal, setIsAddSessionModal] = useState(false);
  
  // Form array for multiple sessions
  const [sessionForms, setSessionForms] = useState([
    {
      name: "",
      val: "",
      dom: "",
      path: "/",
      fnd: "",
      expires: ""
    }
  ]);

  useEffect(() => {
    if (orgId) {
      fetchLeakedSession(orgId, dispatch, page, filterData, search, category, domainSelected, domainvalue, startDate, endDate, limit);
    } else {
      fetchLeakedSession(id, dispatch, page, filterData, search, category, domainSelected, domainvalue, startDate, endDate, limit);
    }
  }, [id, dispatch, page, filterData, search, category, domainSelected, domainvalue, startDate, endDate, limit]);

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount]);

  useEffect(() => {
    fetchLeakedSessionGraph(id, dispatch);
  }, [id, dispatch]);

  let response = state;

  // response = response?.sort((a, b) => (new Date(a.fnd * 1000).getTime() > new Date(b.fnd * 1000).getTime()) ? -1 : ((new Date(b.fnd * 1000).getTime() > new Date(a.fnd * 1000).getTime()) ? 1 : 0))

  let mapData = response;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/leaked-sessions/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}LeakedSession.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green", // Customize as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                leakedSessionIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchLeakedSessionAction(
                id,
                dispatch,
                page,
                filterData,
                search,
                category,
                data
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      leakedSessionIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchLeakedSessionAction(
      id,
      dispatch,
      page,
      filterData,
      search,
      category,
      data
    );
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      leakedSessionIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchLeakedSessionAction(
      id,
      dispatch,
      page,
      filterData,
      search,
      category,
      data
    );
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const reScan = () => {
    let data = {
      "moduleName": ["leakedSession"]
    }
    rescanSingle(id, data)
  }

  const resetSessionForm = () => {
    setSessionForms([
      {
        name: "",
        val: "",
        dom: "",
        path: "/",
        fnd: "",
        expires: ""
      }
    ]);
  };

  const handleInputChange = (index, field, value) => {
    const updatedForms = [...sessionForms];
    updatedForms[index][field] = value;
    setSessionForms(updatedForms);
  };

  const addSessionForm = () => {
    setSessionForms([
      ...sessionForms,
      {
        name: "",
        val: "",
        dom: "",
        path: "/",
        fnd: "",
        expires: ""
      }
    ]);
  };

  const removeSessionForm = (index) => {
    const updatedForms = [...sessionForms];
    updatedForms.splice(index, 1);
    setSessionForms(updatedForms);
  };

  const handleSessionSubmit = () => {
    // Validate form input
    let hasErrors = false;
    let errorMessage = "";
    
    sessionForms.forEach((session, index) => {
      if (!session.name) {
        hasErrors = true;
        errorMessage = `Session #${index + 1}: Name is required`;
      } else if (!session.val) {
        hasErrors = true;
        errorMessage = `Session #${index + 1}: Value is required`;
      } else if (!session.dom) {
        hasErrors = true;
        errorMessage = `Session #${index + 1}: Domain is required`;
      }
    });
    
    if (hasErrors) {
      toastr.error("Validation Error", errorMessage);
      return;
    }
    
    // Format data properly
    const formattedData = sessionForms.map(session => {
      const formattedSession = {
        ...session,
        expires: session.expires ? (() => {
          // Handle both date input (YYYY-MM-DD) and ISO string formats
          const date = new Date(session.expires);
          if (isNaN(date.getTime())) {
            return undefined; // Invalid date
          }
          return Math.floor(date.getTime() / 1000); // Convert to Unix timestamp
        })() : undefined
      };
      
      // Remove undefined fields or empty strings
      Object.keys(formattedSession).forEach(key => {
        if (formattedSession[key] === undefined || formattedSession[key] === "") {
          delete formattedSession[key];
        }
      });
      
      return formattedSession;
    });
    
    // Always send as array
    addLeakedSession(id,
      {
      data: formattedData,
      callback: () => {
        // Reset form and close modal on success
        resetSessionForm();
        setIsAddSessionModal(false);
        // Refresh the data
        fetchLeakedSession(id, dispatch, page, filterData, search, category, domainSelected, domainvalue, startDate, endDate, limit);
      }
    });
  };

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
           <h1 className="welcome-text"></h1>
            <h1 className="welcome-text">Leaked Sessions (Stealer Logs) </h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Leaked Sessions
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            
           
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
            
          </div>
        </div>
      </div>

      {/* Recommendation Alert Banner */}
      {/* {category === "all" && totalCount > 0 && (
        <div className="card border-danger mb-3">
          <div className="card-body">
            <div className="d-flex align-items-start">
              <div className="mr-3">
                <i className="fa fa-exclamation-triangle text-danger" style={{ fontSize: "24px" }}></i>
              </div>
              <div className="flex-grow-1">
                <h6 className="text-danger mb-2">
                  🚨 Alert: {totalCount} leaked sessions have been identified from stealer logs.
                </h6>
                <p className="mb-2">
                  Immediate remediation is advised to prevent session hijacking, unauthorized access, and potential data breaches through active sessions.
                </p>
                <div className="mb-3">
                  <strong>🔐 Recommended Actions:</strong>
                  <ul className="mb-0 mt-2" style={{ paddingLeft: "20px" }}>
                    <li>Immediately invalidate all affected sessions and force re-authentication for compromised accounts.</li>
                    <li>Enable session timeout policies and implement secure session management practices.</li>
                    <li>Monitor for suspicious login patterns and implement additional authentication controls.</li>
                  </ul>
                </div>
                <div className="d-flex align-items-center">
                  <i className="fa fa-info-circle text-primary mr-2"></i>
                  <span className="text-primary">
                    👉 For more details, see the{" "}
                    <a 
                      href="https://brandsek.com/kb/books/leaked-sessions" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: "#007bff", textDecoration: "underline" }}
                    >
                      BrandSek Advisory Guide
                    </a>
                    .
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      <div className="row clearfix">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <div>Previous scan details</div>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates}
                  ipArray={oldDnsDetails?.scanDetails}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setfilterData("all");
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setfilterData("all");
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setfilterData("all");
              setSearch("");
              setSelectedIds([]);
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setfilterData("all");
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row">
            <div className="col-sm-4">
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                value={filterData}
                onChange={(e) => { setfilterData(e.target.value); setPage(1) }}
              >
                <option value="all">All</option>
                <option value="live-session">Live Sessions</option>
              </select>
            </div>
            <div className="col-sm-4">
              <div
                data-test="datatable-input"
                class="mdb-datatable-filter flex-row"
              >
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-4">
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                onChange={(e) => setDomainSelected(e.target.value)}
              >
                <option value="">
                  Please select this filter
                </option>
                <option value="filterDomDomain">
                  Dom Domain
                </option>
              </select>
            </div>
            {domainSelected == 'filterDomDomain' ?
              <>
                <div className="col-sm-4">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    onChange={(e) => setDomains(e.target.value)}
                  >
                    <option value="">
                      Please Select Domain
                    </option>
                    {domainValue?.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </> : null
            }
            <div className="col-sm-4 d-flex align-items-end">
              <label htmlFor="startDate">From:</label>
              <input
                type="date"
                className="ml-1 form-control form-control-sm"
                id="startDate"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setPage(1);
                }}
              />
            </div>
            <div className="col-sm-4 d-flex align-items-end">
              <label htmlFor="endDate">Till:</label>
              <input
                type="date"
                className="ml-1 form-control form-control-sm"
                id="endDate"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  setPage(1);
                }}
              />
            </div>
            <div className="col-sm-4">
              {selectedIds.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" || category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => Unsnoozed("")}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5">
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={selectedIds == 0 ? false : multiCheckTrue}
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th>Name</th>
                  <th>Domain</th>
                  <th>Value</th>
                  <th>Path</th>
                  <th>Session Expiry</th>
                  <th>Found On</th>
                  {category !== "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th style={{ width: "80" }}>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {client?.subscriptionType == "trial" ? (
                  <tr>
                    <td colSpan={6}>
                      <NoData />
                    </td>
                  </tr>
                ) : (
                  currentTableData?.map((row, index) => {
                    // let value = row?.val?.split("") || ['N', 'A'];
                    let date = row?.fnd
                      ? row?.fnd?.toString().substr(0, 4) +
                      "-" +
                      row?.fnd?.toString().substr(4, 2) +
                      "-" +
                      row?.fnd?.toString().substr(6, 2)
                      : "NA";
                    return (
                      <tr key={`leaked${index}`}>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <input
                                onClick={() => singleClick(row?._id)}
                                checked={selectedIds?.includes(row?._id)}
                                type="checkbox"
                                className="checkUncheck"
                              />
                            </td>
                          )}
                        <td>{row?.name || "NA"}</td>
                        <td style={{ width: "100px" }}>{row?.dom || "NA"}</td>
                        <td
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            cursor: "pointer", // Add cursor style to indicate it's clickable
                          }}
                        >
                          <span title={row?.val}>
                            {(row?.val || "NA").slice(0, 50)}
                          </span>
                        </td>

                        <td style={{ width: "100px" }}>
                          {row?.path || "NA"}
                        </td>
                        <td style={{ whiteSpace: "unset" }}>
                          {row?.expires
                            ? (() => {
                                // Handle both Unix timestamp and ISO string formats
                                if (typeof row.expires === 'string' && row.expires.includes('T')) {
                                  // ISO string format
                                  return moment(row.expires).format("DD-MM-YYYY");
                                } else {
                                  // Unix timestamp format
                                  return moment(row.expires * 1000).format("DD-MM-YYYY");
                                }
                              })()
                            : "NA"}
                        </td>

                        <td style={{ whiteSpace: "unset" }}>
                          {row?.createdAt
                            ? moment(row?.createdAt).format(
                              "DD-MM-YYYY"
                            )
                            : "NA"}
                        </td>
                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                          <td>
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze(row?._id, event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId(row._id);
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId(row._id);
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemidiated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </td>
                        )}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed(row?._id)}
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItems > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItems}
                  pageSize={limit}
                  onPageChange={(page) => setPage(page)}
                />
              )}
            </div>
            {totalItems > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Session Modal */}
      <div className={`modal fade Form-Wizard-modal ${isAddSessionModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg" id="addSessionModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Leaked Session</h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  resetSessionForm();
                  setIsAddSessionModal(false);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      {sessionForms.map((session, index) => (
                        <div key={index} className="session-form mb-4">
                          {index > 0 && (
                            <div className="d-flex justify-content-between mb-2">
                              <h6>Session #{index + 1}</h6>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => removeSessionForm(index)}
                              >
                                Remove
                              </button>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Session Name*</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={session.name}
                                  onChange={(e) => handleInputChange(index, "name", e.target.value)}
                                  placeholder="Session name"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Domain*</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={session.dom}
                                  onChange={(e) => handleInputChange(index, "dom", e.target.value)}
                                  placeholder="example.com"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Session Value*</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={session.val}
                                  onChange={(e) => handleInputChange(index, "val", e.target.value)}
                                  placeholder="Session value"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Path</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={session.path}
                                  onChange={(e) => handleInputChange(index, "path", e.target.value)}
                                  placeholder="/"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Found Location</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={session.fnd}
                                  onChange={(e) => handleInputChange(index, "fnd", e.target.value)}
                                  placeholder="Where it was found"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Expiry Date</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={session.expires}
                                  onChange={(e) => handleInputChange(index, "expires", e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          {index < sessionForms.length - 1 && <hr />}
                        </div>
                      ))}
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={addSessionForm}
                          >
                            + Add Another Session
                          </button>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12 col-md-12 text-right">
                          <button 
                            className="btn btn-default mr-2" 
                            onClick={() => {
                              resetSessionForm();
                              setIsAddSessionModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button className="btn btn-primary" onClick={handleSessionSubmit}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div
          className="recommendation-modal-overlay"
          onClick={() => setIsRecommendationModal(false)}
        >
          <div
            className="recommendation-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="recommendation-modal-close"
              onClick={() => setIsRecommendationModal(false)}
            >
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified active session identifiers and cookie values associated with
                  the organization that have been exposed on dark web and underground sources. These
                  session artifacts are considered <strong>fully compromised</strong> and may allow
                  attackers to bypass authentication controls.
                </div>

                <div className="guide-section">
                  <h3>What Are Leaked Sessions</h3>
                  <p>
                    Leaked sessions refer to stolen authentication cookies, session IDs, UUIDs, or
                    persistent tokens that maintain an authenticated user state. These values are
                    commonly harvested via malware, browser compromise, malicious extensions, or
                    insecure endpoint storage.
                  </p>
                </div>

                <div className="guide-section">
                  <h3>Why This Is Critical</h3>
                  <ul>
                    <li>Session cookies can allow direct access without username or password</li>
                    <li>Long expiry dates significantly increase exploitation windows</li>
                    <li>Attackers can impersonate legitimate users undetected</li>
                    <li>Standard password resets may not invalidate active sessions</li>
                  </ul>
                </div>

                <div className="guide-section">
                  <h3>How Attackers Exploit Leaked Sessions</h3>
                  <ul>
                    <li>Replay stolen cookies to hijack authenticated sessions</li>
                    <li>Access portals, dashboards, and payment flows as legitimate users</li>
                    <li>Perform fraud, data extraction, or account manipulation</li>
                    <li>Maintain persistence until session expiry or manual invalidation</li>
                  </ul>
                </div>

                <div className="guide-section">
                  <h3>Recommended Response Strategy</h3>
                  <p>
                    Leaked session values must be treated as an active security incident. Response
                    actions should prioritize session invalidation, token rotation, endpoint review,
                    and strengthening of session management controls.
                  </p>
                </div>

                <div className="guide-section">
                  <h3>Governance & Compliance Considerations</h3>
                  <p>
                    Session compromise incidents should be documented and tracked to meet ISO 27001
                    incident management requirements, RBI Cyber Security Framework expectations, and
                    CERT-In advisory guidance on authentication security.
                  </p>
                </div>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Session Invalidation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Invalidate all active sessions for affected users</li>
                      <li>Revoke session cookies and tokens server-side</li>
                      <li>Force re-authentication across applications</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · CERT-In</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Credential & Token Rotation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Rotate associated passwords and secrets</li>
                      <li>Reissue authentication and refresh tokens</li>
                      <li>Validate token scope and expiration policies</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · RBI IAM Controls</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Endpoint & Browser Security Review</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Inspect endpoints for malware or malicious extensions</li>
                      <li>Clear browser storage and cached sessions</li>
                      <li>Rebuild or reimage compromised systems if required</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.7 · CERT-In Malware Guidance</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Session Management Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Reduce session lifetime and idle timeout values</li>
                      <li>Enforce secure, HttpOnly, and SameSite cookie flags</li>
                      <li>Bind sessions to IP or device context where feasible</li>
                    </ul>
                    <div className="compliance-tag">OWASP Session Management · ISO 27001</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring, Audit & Risk Documentation</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Monitor for reuse of leaked session values</li>
                      <li>Document incident and remediation steps</li>
                      <li>Include findings in audit and risk registers</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.24 · RBI Governance</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default LeakedSession;
